import { BaseModel } from '../base-model';

export interface IRecurrencePatternObject {
  DailyRecurrenceMode?: string;
  DayOfMonth?: number;
  DayOfWeek?: string;
  EndTime?: string;
  Interval?: number;
  MonthOfYear?: number;
  OccurrenceInMonth?: string;
  Occurrences?: number;
  PatternEndDate?: string;
  PatternStartDate?: string;
  RecurrenceEndMode?: string;
  RecurrenceType?: string;
  StartTime?: string;
}
export class RecurrencePatternObject extends BaseModel<IRecurrencePatternObject> implements IRecurrencePatternObject {
  constructor(options?: IRecurrencePatternObject) {
    super(options);
  }
}